import { DateSelectArg, DayCellContentArg } from "@fullcalendar/core";
import ruLocale from "@fullcalendar/core/locales/ru";
import interactionPlugin from "@fullcalendar/interaction";
import multiMonthPlugin from "@fullcalendar/multimonth";
import FullCalendar from "@fullcalendar/react";
import React, { useContext, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Context } from "..";
import { IHolidays } from "../models/IHolidays";
import { Link, useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
const initialValue: IHolidays = {
  dateFrom: "",
  dateUntil: "",
  periodId: "",
  userId: "",
};

interface IEvent {
  start: string;
  end: string;
  title?: string;
  backgroundColor: string;
  editable: boolean;
  display: string;
  className: string;
}

const Holiday = () => {
  const { store } = useContext(Context);
  const [value, setValue] = useState<IHolidays>(initialValue);
  const [calendarEvents, setCalendarEvents] = useState<IEvent[]>([]);
  const navigate = useNavigate();
  useEffect(() => {
    if (store.user.department?._id) {
      store.getHolidaysById(store.user.department?._id).then(() => {
        const events: IEvent[] = store.userHolidays.map((holiday) => ({
          start: holiday.dateFrom,
          end: holiday.dateUntil,
          title:
            store.user?.id === holiday.userId
              ? `Запланированный отпуск ${holiday.name}`
              : `Отпуск сотрудника ${holiday.name}`,
          backgroundColor:
            store.user?.id === holiday.userId ? "#2eb62c" : "#ffcc00",
          editable: false,
          display: "auto",
          className: "fullcalendar",
        }));
        setCalendarEvents(events);
      });
    }
  }, [store, store.user.department?._id]);

  useEffect(() => {
    if (store.user.department?._id) {
      store.getDepartmentById(store.user.department?._id);
    }
  }, [store.user.department?._id]);
  const handleDateSelect = (selectInfo: DateSelectArg) => {
    const calendarApi = selectInfo.view.calendar;
    const startDateStr = selectInfo.startStr;
    const endDate = new Date(selectInfo.end);
    endDate.setDate(endDate.getDate());
    const endDateStr = endDate.toISOString().split("T")[0];
    setValue({
      dateFrom: startDateStr,
      dateUntil: endDateStr,
      userId: store.user.id,
    });
    calendarApi.unselect();
  };

  const submitHandler = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    store.createHolidays(value).then(() => {
      navigate(`/profile/${store.user.id}`);
    });
  };

  const getDayCellClassNames = (arg: DayCellContentArg) => {
    const date = arg.date;
    const classNames = ["fullcalendar"];
    const isRestricted = store.onedepartment.restrictedHolidays?.some(
      (holiday) => {
        const fromDate = new Date(holiday.from);
        const toDate = new Date(holiday.to);
        return date >= fromDate && date <= toDate;
      }
    );

    if (isRestricted) {
      classNames.push("red-day");
      arg.isDisabled = true; 
    }

    return classNames;
  };

  const changeHandler = (fields: Partial<IHolidays>) => {
    setValue((prev) => {
      return { ...prev, ...fields };
    });
  };

  return (
    <div className="container">
      <h2>Выбрать отпуск</h2>
      <form onSubmit={submitHandler}>
        <div>
          <Form.FloatingLabel
            label="Дата начала отпуска"
            className="mb-2"
            controlId="floatingInput"
          >
            <Form.Control
              onChange={(e) =>
                changeHandler({
                  dateFrom: e.target.value,
                  userId: store.user.id,
                })
              }
              // max={maxDate}
              required={true}
              value={value.dateFrom}
              type="date"
              name="dateFrom"
              // disabled={user.employmentDateChanged ? true : false}
            />
          </Form.FloatingLabel>
          <Form.FloatingLabel
            label="Дата окончания отпуска"
            className="mb-2"
            controlId="floatingInput"
          >
            <Form.Control
              onChange={(e) =>
                changeHandler({
                  dateUntil: e.target.value,
                  userId: store.user.id,
                })
              }
              value={value.dateUntil}
              required={true}
              type="date"
              name="dateUntil"
            />
          </Form.FloatingLabel>
        </div>
        <button type="submit" className="btn btn-primary btn-block">
          Подтвердить
        </button>
        <Link
          className="btn btn-secondary mx-2"
          to={`/profile/${store.user.id}`}
        >
          Отмена
        </Link>
      </form>
      <h2 className="mt-4">Календарь занятых отпусков</h2>
      <p>Выберите год и Вы сможете увидеть, какие даты еще свободны</p>
      <div>
        <FullCalendar
          events={calendarEvents}
          locale={ruLocale}
          plugins={[multiMonthPlugin, interactionPlugin]}
          initialView="multiMonthYear"
          showNonCurrentDates={true}
          selectable={true}
          select={handleDateSelect}
          dayCellClassNames={getDayCellClassNames}
        />
      </div>
    </div>
  );
};

export default observer(Holiday);
